/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Valid values for a date-criterion in a Query
 */
export enum BioSamplingContainerDateRangeFieldsV1 {
    KIT_EXPIRATION_DATE = 'KIT_EXPIRATION_DATE',
    LAST_MODIFIED = 'LAST_MODIFIED',
    CREATED_AT = 'CREATED_AT',
}